<template>
	<div id="plate-groups">
		<menu-component></menu-component>
		<div id="screen-container" class="screen-container">
			<default-header></default-header>
			<div id="panel-container">
				<collapsible-panel :panel="view.mainPanel"
				:folded="view.mainPanel.collapsed" v-if="view.mainPanel.isVisible"
				@collapsed="(collapsed) => {view.mainPanel.onChangeCollapse(collapsed); view.mainPanel.collapsed = collapsed;}"
				:class="{'collapsible-panel-fullscren': view.mainPanel.fullscreen}">
					<div class="double-grid-container">
						<grid-component
							id="groupGrid" class="half-grid"
							:grid="view.mainPanel.groupGrid.gridConfiguration"
							@update:isAddingNewRow="setAddingNewRowOnDoubleGrid(view.mainPanel.groupGrid, $event)"
						/>
						<div class="half-grid">
							<grid-component
								id="platesGrid" 
								:grid="view.mainPanel.platesGrid.gridConfiguration"
								@update:isAddingNewRow="setAddingNewRowOnDoubleGrid(view.mainPanel.platesGrid, $event)"
								@update:hasCheckedRows="(ev) => updateCheckedRows(view.mainPanel.platesGrid.gridConfiguration, ev)"
							>
							</grid-component>
							<div class="grid-overlay" v-show="!view.mainPanel.platesGrid.gridConfiguration.hideFilterOverlay">
								<span>{{$t('select_a_group_of_dishes_from_the_list_on_the_side')}}</span>
							</div>
						</div>
					</div>


				<div class="double-grid-btn-container">
					<!-- lado esquerdo (grupo da grid da esquerda) -->
					<span class="button-div">
						<button class="button grid-button" @click="addPlateGroup"><i class="fas fa-plus"></i> {{$t('new')}}</button>
						<button class="button grid-button" @click="delPlateGroup"
								v-show="!view.mainPanel.groupGrid.gridConfiguration.isAddingNewRow">
						<i class="fas fa-trash"></i> {{$t('delete')}}
						</button>
						<button class="button grid-button"
								@click="showExportModal('GROUP', 'groupGrid', 'Exportar Grupo', true)"
								v-show="!view.mainPanel.groupGrid.gridConfiguration.isAddingNewRow">
						<i class="fas fa-file-export"></i> {{$t('export_group')}}
						</button>
						<button class="button grid-button"
								v-show="view.mainPanel.groupGrid.gridConfiguration.isAddingNewRow"
								@click="() => removeNewRowOnDoubleGrid(view.mainPanel.groupGrid)">
						<i class="fas fa-times"></i> {{$t('cancel')}}
						</button>
					</span>

					<!-- lado direito (fica abaixo da grid da direita) -->
					<span class="right-grid-button-container">
						<!-- grupo principal de botões da grid da direita -->
						<div class="button-div">
						<button class="button grid-button" @click="addPlateRegister"
								:class="{'disabled':view.mainPanel.platesGrid.gridConfiguration.disablePlateAdd}">
							<i class="fas fa-plus"></i> {{$t('new')}}
						</button>
						<button class="button grid-button" @click="delPlateRegister"
								v-show="!view.mainPanel.platesGrid.gridConfiguration.isAddingNewRow"
								:class="{'disabled':view.mainPanel.platesGrid.gridConfiguration.disablePlateDel}">
							<i class="fas fa-trash"></i> {{$t('delete')}}
						</button>
						<button class="button grid-button"
								@click="showExportModal('GROUP', 'platesGrid', 'Exportar Pratos', false)"
								v-show="view.mainPanel.platesGrid.gridConfiguration.hasCheckedRows && 
										!view.mainPanel.platesGrid.gridConfiguration.isAddingNewRow"
								:class="{'disabled':view.mainPanel.platesGrid.gridConfiguration.disablePlateDel}">
							<i class="fas fa-file-export"></i> {{$t('export_dishes')}}
						</button>
						<button class="button grid-button"
								v-show="view.mainPanel.platesGrid.gridConfiguration.isAddingNewRow"
								@click="() => removeNewRowOnDoubleGrid(view.mainPanel.platesGrid)">
							<i class="fas fa-times"></i> {{$t('cancel')}}
						</button>
						</div>

						<!-- botões “fullscreen / export” continuam à direita -->
						<div class="fullscreen-button button-div">
						<button class="button gray-button" @click="exportToExcelGroupPanel(view.mainPanel)">
							<i class="fas fa-file-excel"></i><span> {{$t('export')}} </span>
						</button>
						<button class="button gray-button" @click="invertValue(view.mainPanel,'fullscreen')">
							<div v-show="!view.mainPanel.fullscreen"><i class="fas fa-expand-arrows-alt"></i></div>
							<div v-show="view.mainPanel.fullscreen"><i class="fas fa-compress-arrows-alt"></i></div>
						</button>
						</div>
					</span>
				</div>


 				</collapsible-panel>
				<collapsible-panel :panel="view.grouplessPlatesPanel" 
				:folded="view.grouplessPlatesPanel.collapsed"
				v-if="view.grouplessPlatesPanel.isVisible"
				@collapsed="(v) => sync(v, view.grouplessPlatesPanel, 'collapsed')"
				:class="{'collapsible-panel-fullscren': view.grouplessPlatesPanel.fullscreen}">
					<div class="grid-container">
						<grid-component
							class="low-height-grid"
							id="parametersGrid"
							:grid="view.grouplessPlatesPanel.gridConfiguration"
						></grid-component>
						<div class="button-container">
							<div class="button-container-align-right full-width">
								<button class="button gray-button" @click="exportToExcel(view.grouplessPlatesPanel)">
									<i class="fas fa-file-excel"></i>
									<span> {{$t('export')}} </span> 
								</button>
								<button class="button gray-button" 
								@click="invertValue(view.grouplessPlatesPanel,'fullscreen')">
										<span v-show="!view.grouplessPlatesPanel.fullscreen">
											<i class="fas fa-expand-arrows-alt"></i>
										</span>
										<span v-show="view.grouplessPlatesPanel.fullscreen">
											<i class="fas fa-compress-arrows-alt"></i>
										</span>
								</button>
							</div>
						</div>
					</div>
 				</collapsible-panel>
				<collapsible-panel :panel="view.plateGroupGroupingPanel" 
				:folded="view.plateGroupGroupingPanel.collapsed"
				v-if="view.plateGroupGroupingPanel.isVisible"
				@collapsed="(v) => sync(v, view.plateGroupGroupingPanel, 'collapsed')"
				:class="{'collapsible-panel-fullscren': view.plateGroupGroupingPanel.fullscreen}">
					<div class="grid-container">
						<grid-component
							class="low-height-grid"
							id="parametersGrid"
							:grid="view.plateGroupGroupingPanel.gridConfiguration"
							@update:isAddingNewRow="updateIsAddingNewRow(view.plateGroupGroupingPanel, $event)"
							@update:hasCheckedRows="(ev) => updateCheckedRows(view.plateGroupGroupingPanel, ev)"
						></grid-component>
					</div>
					<div class="button-container">
						<div class="button-div">
							<button class="button grid-button" @click="addPlateGroupGroupingRow">
								<i class="fas fa-plus"></i> {{$t('new')}} </button>
							<button class="button grid-button" 
								v-show="view.plateGroupGroupingPanel.hasCheckedRows &&
								!view.plateGroupGroupingPanel.isAddingNewRow"
								@click="callController('deletePlateGroupGrouping', [view.plateGroupGroupingPanel])"> 
							<i class="fas fa-trash"></i> {{$t('delete')}} </button>
							<button class="button grid-button"
							v-show="view.plateGroupGroupingPanel.isAddingNewRow"
							@click="() => removeNewRow(view.plateGroupGroupingPanel)">
								<i class="fas fa-times"></i> {{$t('cancel')}} </button>
						</div>
						<div class="button-container-align-right">
							<button class="button gray-button" @click="exportToExcel(view.plateGroupGroupingPanel)">
								<i class="fas fa-file-excel"></i>
								<span> {{$t('export')}} </span> 
							</button>
							<button class="button gray-button" 
							@click="invertValue(view.plateGroupGroupingPanel,'fullscreen')">
								<span v-show="!view.plateGroupGroupingPanel.fullscreen">
									<i class="fas fa-expand-arrows-alt"></i>
								</span>
								<span v-show="view.plateGroupGroupingPanel.fullscreen">
									<i class="fas fa-compress-arrows-alt"></i>
								</span>
							</button>
						</div>
					</div>
 				</collapsible-panel>
				<collapsible-panel :panel="view.plateGroupStandardPanel" 
				:folded="view.plateGroupStandardPanel.collapsed" v-if="view.plateGroupStandardPanel.isVisible"
				@collapsed="(v) => sync(v, view.plateGroupStandardPanel, 'collapsed')"
				:class="{'collapsible-panel-fullscren': view.plateGroupStandardPanel.fullscreen}">
					<div class="grid-container">
						<grid-component
							class="low-height-grid"
							id="parametersGrid"
							:grid="view.plateGroupStandardPanel.gridConfiguration"
							@update:isAddingNewRow="updateIsAddingNewRow(view.plateGroupStandardPanel, $event)"
							@update:hasCheckedRows="(ev) => updateCheckedRows(view.plateGroupStandardPanel, ev)"
						></grid-component>
					</div>
					<div class="button-container">
						<div class="button-div">
							<button class="button grid-button" @click="addPlateGroupStandardRow">
								<i class="fas fa-plus"></i> {{$t('new')}} </button>
							<button class="button grid-button" 
								v-show="view.plateGroupStandardPanel.hasCheckedRows &&
								!view.plateGroupStandardPanel.isAddingNewRow"
								@click="callController('deletePlateGroupStandard', [view.plateGroupStandardPanel])"> 
							<i class="fas fa-trash"></i> {{$t('delete')}} </button>
							<button class="button grid-button"
							v-show="view.plateGroupStandardPanel.isAddingNewRow"
							@click="() => removeNewRow(view.plateGroupStandardPanel)">
								<i class="fas fa-times"></i> {{$t('cancel')}} </button>
						</div>
						<div class="button-container-align-right">
							<button class="button gray-button" @click="exportToExcel(view.plateGroupStandardPanel)">
								<i class="fas fa-file-excel"></i>
								<span> {{$t('export')}} </span> 
							</button>
							<button class="button gray-button" 
							@click="invertValue(view.plateGroupStandardPanel,'fullscreen')">
								<span v-show="!view.plateGroupStandardPanel.fullscreen">
									<i class="fas fa-expand-arrows-alt"></i>
								</span>
								<span v-show="view.plateGroupStandardPanel.fullscreen">
									<i class="fas fa-compress-arrows-alt"></i>
								</span>
							</button>
						</div>
					</div>
 				</collapsible-panel>
			</div>
		</div>

		<modal name="recipe-modal" @opened="view.recipeModal.onOpenModal">
			<grid-component
				class="recipe-grid"
				id="recipeGrid"
				:grid="view.recipeModal.gridConfiguration"
			></grid-component>
		</modal>
		<modal
			name="export-form-modal" 
			:height="'auto'" 
			:clickToClose="false"
		>
			<export-form
				:modal="$modal"
				:name="view.exportDataModal._name"
				:modalStyle="view.exportDataModal._style"
				:showLoad="view.exportDataModal._showLoad"
				:showMultiGroup="view.exportDataModal._multiGroup"
				@saveExport="saveExport"
			/>
		</modal>
	</div>
</template>

<script>
import PlateGroupsController from '../controllers/PlateGroupsController'

import MenuComponent from '@/components/src/MenuComponent';
import DefaultHeader from '@/components/src/DefaultHeaderComponent';
import CollapsiblePanel from '@/components/src/CollapsiblePanelComponent';
import Grid from "@/components/src/GridComponent";
import eventModule from '@/application/libs/eventModule';
import Util from '@/application/libs/util';
import ExcelBuilder from  '@/application/libs/excelBuilder'
import permissionManager from "@/application/libs/permissionManager"
import ExportForm from '@/components/src/ExportForm'
import { t } from 'i18next'

export default {
	name: "Plates",
	components:{
		'menu-component':MenuComponent,
		'default-header':DefaultHeader,
		'collapsible-panel':CollapsiblePanel,
		'grid-component': Grid,
		'export-form': ExportForm
	},
	data() {
		return {
			view: {
				title: t('group_of_dishes'),
				plateGroupStandardPanel:{
					title: t('dish_group_pattern'),
					name:"plateGroupStandardPanel",
					gridConfiguration : PlateGroupsController.plateGroupStandardGridConfig,
					collapsed: true,
					hasCheckedRows: false,
					fullscreen: false,
					isAddingNewRow: false,
					isVisible: true,
					info: t('info_dish_group_pattern')
				},
				plateGroupGroupingPanel:{
					title: t('dish_group_grouping'),
					name:"plateGroupGroupingPanel",
					gridConfiguration : PlateGroupsController.plateGroupGroupingGridConfig,
					collapsed: true,
					hasCheckedRows: false,
					fullscreen: false,
					isAddingNewRow: false,
					isVisible: true,
					info: t('info_dish_group_grouping') + `\n` + t('info_2_dish_group_grouping')
				},
				grouplessPlatesPanel:{
					title: t('dishes_not_linked_to_dish_group'),
					name:"grouplessPlatesPanel",
					gridConfiguration : PlateGroupsController.grouplessPlatesGridConfig,
					collapsed: true,
					fullscreen: false,
					isVisible: true,
					info: t('info_dishes_not_linked_to_dish_group') + `\n` + t('info_2_dishes_not_linked_to_dish_group')
				},
				mainPanel:{
					collapsed:false,
					fullscreen:false,
					isVisible: true,
					title: t('group_of_dishes'),
					name:"plateGroup",
					info: t('info_group_of_dishes') + `\n` + t('info_2_group_of_dishes') + `\n` + t('info_3_group_of_dishes') + `\n` + t('info_4_group_of_dishes') + `\n` + t('info_5_group_of_dishes') ,
					onChangeCollapse:PlateGroupsController.onChangeMainPanelCollapse,
					groupGrid:{
						gridConfiguration: Object.assign(PlateGroupsController.groupGridConfiguration, {
							isAddingNewRow: false
						})
					},
					platesGrid:{
						gridConfiguration: Object.assign(PlateGroupsController.platesGridConfiguration, {
							hideFilterOverlay:false,
							disablePlateAdd:true,
							disablePlateDel:true,
							isAddingNewRow: false,
							hasCheckedRows: false
						})
					},
				},
				recipeModal:{
					gridConfiguration:PlateGroupsController.recipeGrid,
					onOpenModal:()=>{
						let recipeGrid = this.view.recipeModal.gridConfiguration;
						recipeGrid.setRowData(recipeGrid.__data);
						delete recipeGrid.__data;
					}
				},
				exportDataModal: {
					_showLoad: true
				}
			}
		};
	},
	created(){
		eventModule.$on("updateBoData", this.refreshPlateGroupViewGrids);
		PlateGroupsController.CDPICTPRAT = Util.getFilterInSession().CDPICTPRAT;
		PlateGroupsController.CDPICTPROD = Util.getFilterInSession().CDPICTPROD;
		const permissions = permissionManager.getPlateGroupsViewPermissions();
		Object.keys(permissions).forEach(panelName => this.view[panelName].isVisible = permissions[panelName]);
		// let colDef = PlateGroupsController.grouplessPlatesGridConfig.columnDefs.find(cd => cd.field === 'CDPRATO');
		// colDef.valueFormatter = Util.maskFactory(PlateGroupsController.CDPICTPRAT); 
	},
	mounted() {
		document.title = `${this.view.title} - Cardápio Inteligente`;

		// let platesGrid = this.view.mainPanel.platesGrid;
		// let groupGrid = this.view.mainPanel.groupGrid;
		PlateGroupsController.vueContext = this;
		// groupGrid.gridConfiguration.advancedOptions.onRowClicked = PlateGroupsController.onGroupRowClicked;
		// groupGrid.gridConfiguration.advancedOptions.onSelectionChanged = PlateGroupsController.removeNewRowOnRowDeselection;
		
		// platesGrid.gridConfiguration.advancedOptions.onRowDoubleClicked = (params)=>PlateGroupsController.onPlateRowDbClicked(params, this);
		// platesGrid.gridConfiguration.advancedOptions.onSelectionChanged = PlateGroupsController.removeNewRowOnRowDeselection;
		
	},
	beforeDestroy(){
		eventModule.$off("updateBoData", this.refreshPlateGroupViewGrids);
	},
	methods: {
		sync: (v, obj, propName) =>  obj[propName] = v,
		addPlateGroupGroupingRow: function(){PlateGroupsController.plateGroupGroupingGridConfig.addNewRowToGrid()},
		addPlateGroupStandardRow: function(){PlateGroupsController.plateGroupStandardGridConfig.addNewRowToGrid()},
		callController: function(methodName, params = []) {
			return PlateGroupsController[methodName] && PlateGroupsController[methodName](...params);
		},
		addPlateGroup(){
			this.view.mainPanel.groupGrid.gridConfiguration.addNewRowToGrid(true, true, false);
		},
		delPlateGroup: function(params){
			PlateGroupsController.delPlateGroup(params, this.$modal);
		},
		invertValue: function(object, key){
			object[key] = !object[key];
		},
		addPlateRegister(){
			this.view.mainPanel.platesGrid.gridConfiguration.addNewRowToGrid(/*true, true, false*/);
		},
		refreshPlateGroupViewGrids(ev){
			let contractTypeHasChanged = ev.oldValue.TPCONTRATO !== ev.newValue.TPCONTRATO;

			!this.view.grouplessPlatesPanel.collapsed && this.view.grouplessPlatesPanel.gridConfiguration.reloadData();
			
			if(!this.view.plateGroupGroupingPanel.collapsed && contractTypeHasChanged){
				 this.view.plateGroupGroupingPanel.gridConfiguration.reloadData();
			}
			if(!this.view.plateGroupStandardPanel.collapsed && contractTypeHasChanged){ 
				this.view.plateGroupStandardPanel.gridConfiguration.reloadData();
			}

			if(!this.view.mainPanel.collapsed){
				let groupGrid = this.view.mainPanel.groupGrid;
				groupGrid.gridConfiguration.reloadData();
			}
		},
		delPlateRegister:PlateGroupsController.delPlateRegister,
		updateCheckedRows: function(panel, value){
			if(panel.isAddingNewRow){
				let selectedRows = panel.gridConfiguration.advancedOptions.api.getSelectedRows(); 
				panel.hasCheckedRows = (selectedRows.length && (selectedRows.length > 1 || !selectedRows[0].__is_new_row)); 
			} else {
				panel.hasCheckedRows = value;
			}
		},
		updateIsAddingNewRow: function(panel, value){
			panel.isAddingNewRow = value;
			!value && panel.gridConfiguration.enableSelection && panel.gridConfiguration.enableSelection();
		},
		setAddingNewRowOnDoubleGrid: function(grid, value){
			grid.gridConfiguration.isAddingNewRow = value;
			!value && grid.gridConfiguration.enableSelection && grid.gridConfiguration.enableSelection();
		},
		removeNewRow: function(panel){
			let rows = panel.gridConfiguration.getRowData();
			rows[0] && rows[0].__is_new_row && (rows[0].__removed = true) && rows.shift();
			panel.gridConfiguration.setRowData(rows);
			panel.gridConfiguration.enableSelection();
			panel.isAddingNewRow = false;
			panel.hasCheckedRows = false;
		},
		removeNewRowOnDoubleGrid: function(grid){
			let rows = grid.gridConfiguration.getRowData();
			rows[0] && rows[0].__is_new_row && (rows[0].__removed = true) && rows.shift();
			grid.gridConfiguration.setRowData(rows);
			grid.gridConfiguration.enableSelection();
			grid.gridConfiguration.isAddingNewRow = false;
			grid.gridConfiguration.hasCheckedRows = false;
		},
		exportToExcel: function(view){
			ExcelBuilder.fromJson(
				Util.getVisibleDataFromGrid(view.gridConfiguration),
				Util.getGridColDefsToColDetails(view.gridConfiguration.columnDefs),
				view.title,
				Util.getExcelHeaderFromFilter(),
			);
		},
		exportToExcelGroupPanel: function(mainPanel) {
			PlateGroupsController.exportGroupPlate().then((response) => {
				const columnDefs = [];
				mainPanel.groupGrid.gridConfiguration.columnDefs.forEach((data) => { columnDefs.push(data) });
				mainPanel.platesGrid.gridConfiguration.columnDefs.forEach((data) => { columnDefs.push(data) });
				ExcelBuilder.fromJson(
					response,
					Util.getGridColDefsToColDetails(columnDefs),
					mainPanel.title,
					Util.getExcelHeaderFromFilter(),
				);
			});
		},
		showExportModal: function(modalStyle, caller, name, multiGroup) {
			const configuration = this.getGridConfiguration(caller);
			if(configuration.table == "ITGRUPOPRATO") {
				const itemList = this.getData(configuration.grid, configuration.item);
				if(itemList.length > 0) {
					this.view.exportDataModal._style = modalStyle;
					this.view.exportDataModal._caller = caller;
					this.view.exportDataModal._name = name;
					this.view.exportDataModal._itemSelected = itemList;
					this.view.exportDataModal._conf = configuration;
					this.view.exportDataModal._multiGroup = multiGroup;
					this.$forceUpdate();
					this.$modal.show('export-form-modal');
				} else {
					Util.showErrorNotification({ title: t('please_select_an_item_to_export')});
				}
			} else {
				this.view.exportDataModal._style = modalStyle;
				this.view.exportDataModal._caller = caller;
				this.view.exportDataModal._name = name;
				this.view.exportDataModal._conf = configuration;
				this.view.exportDataModal._multiGroup = multiGroup;
				this.$forceUpdate();
				this.$modal.show('export-form-modal');
			}
		},
		saveExport: function(view) {
			this.view.exportDataModal._showLoad = false;
			this.view.exportDataModal._mode = view.exportData.mode;
			this.$forceUpdate();

			const filiServ = this.getFiliServ(view.exportData);
			const itemList = (this.view.exportDataModal._conf.table == "ITGRUPOPRATO") ? this.view.exportDataModal._itemSelected : this.getMultiGroup(view.exportData); 
			const plateDataGrid = {};

			if(this.view.exportDataModal._conf.table == "ITGRUPOPRATO") {
				plateDataGrid.MODE = view.exportData.modeGroup;
				plateDataGrid.GROUPARR = view.exportData.selectedGroupPrat.CDGRUPOPRATO;
			} else {
				plateDataGrid.MODE = null;
				plateDataGrid.GROUPARR = null;
			}
			
			PlateGroupsController.callProcedureExportCadOtimizador(filiServ, this.view.exportDataModal._conf.table, itemList, view.exportData.mode, plateDataGrid).then((response) => {
				if(response.data.length > 0) {
					this.showMessageError(response.data);
				} else {
					this.view.exportDataModal._showLoad = true;
					Util.showSuccessNotification({ title: t('successful_export')});
					this.$modal.hide('export-form-modal');
					this.view.mainPanel.groupGrid.gridConfiguration.reloadData();
				}
			});
		},
		getFiliServ: function(data) {
			const filiServ = [];
			if(data.checkedService) {
				data.services.forEach((service) => { filiServ.push(service.CDLISTA) });
			} else {
				data.selectedService.forEach((service) => { filiServ.push(service.CDLISTA) });
			}
			return filiServ;
		},
		getMultiGroup: function(data) {
			const groups = [];
			if(data.checkedMultGroup) {
				data.groupPrat.forEach((group) => { groups.push(group.NRGRUPOPRATOSERV) });
			} else {
				data.selectedGroupPrat.forEach((group) => { groups.push(group.NRGRUPOPRATOSERV) });
			}
			return groups;
		},
		getGridConfiguration:function(caller) {
			if(caller == 'groupGrid') {
				return { table: 'GRUPOPRATO', grid: this.view.mainPanel.groupGrid, item: 'NRGRUPOPRATOSERV' };
			} else if (caller == 'platesGrid') {
				return { table: 'ITGRUPOPRATO', grid: this.view.mainPanel.platesGrid, item: 'NRITGRUPOPRATOSERV' };
			}
		},
		getData:function(grid, item) {
			const arr = [];
			const nodes = grid.gridConfiguration.gridControl.getSelectedRows();
			nodes.forEach((row) => arr.push(row[item]));
			return arr;
		},
		buildMessage:function(data) {
			let message = [];
			data.forEach((error) => {
				let msg = error.DSERRO;
				msg = msg.replace('_MSGSTA_CONSISTE_GRUPOPRATO', '');
				msg = msg.replace("_MSGEND_", "");
				msg = msg.split("$$");
				message.push({ CDFILIAL: msg[1], CDSERVFILI: msg[2], CDGRUPRAT: msg[3] });
			});
			return message;
		},
		showMessageError:function(data) {
			this.view.exportDataModal._showLoad = true;
			const messages = this.buildMessage(data);
			const typeMessage = data[0].DSERRO.split("$")[0];
            this.$modal.show({
                template:`
					<div class="validity-form-root" style="margin: 0; padding: 25px; width: calc(100% - 50px);"> 
						<div v-show="typeMessage != '_MSGSTA_CONSISTE_PRATO'">
							<h3 class="title"> Erros na Exportação: Grupos de Pratos não associados ao serviço destino </h3>
							<div style="max-height: 500px; overflow: auto; padding: 30px 0; width: 100%;">
								<span v-for="message in messages" style="display:block; margin: 10px;"> Unidade: {{message.CDFILIAL}} Serviço: {{message.CDSERVFILI}} 
								Grupo de Prato: {{message.CDGRUPRAT}}</span>
							</div>
						</div>

						<div v-show="typeMessage == '_MSGSTA_CONSISTE_PRATO'"> 
							<h3 class="title"> Erros na Exportação: Prato local não existe na unidade destino </h3>
							<div style="max-height: 500px; overflow: auto; padding: 30px 0; width: 100%;">
								<span v-for="message in messages" style="display:block; margin: 10px;"> Unidade: {{message.CDFILIAL}} Serviço: {{message.CDSERVFILI}} 
								Prato: {{message.CDGRUPRAT}}</span>
							</div>
						</div>

                        <div>
                            <button class="button" style="margin: 15px auto; display: block; min-width: 200px;" @click="close"> OK </button>
                        </div>
                    </div>
                `,
                props: ['messages', 'typeMessage'],
                methods:{
                    close(){this.$emit('close');}
                }
            }, {messages, typeMessage}, {
                height:'auto',
                width:'69%',
            });
		}
	}
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">

	.v--modal-overlay{
		z-index: 10;
	}

	#collapsible-panel.collapsible-panel-fullscren{
		position: fixed;
		top: 48px;
    	left: 100px;
		z-index: 2;
		background-color: white;
		height: calc(100vh - 69px);
    	width: calc(100vw - 125px);
		padding: 20px 15px;
		border-radius: 0;
		padding-top: 0px;
		margin:0;

		#panel-header{
			.up-arrow, .down-arrow{
				display: none;
			}
		}

		#panel-content{
			.ag-grid-instance{
				height: calc(100vh - 126px);
			}
		}
	}

	.select-350{
		.v-select ul{
			width: 350px;
			z-index: 6;
		}
	}
</style>
<style scoped lang="less">
#plate-groups{
	height: 100vh;
	width: 100vw;
	display: flex;

	#header-component{
			position: fixed;
			z-index: 7;
			width: calc(100% - 100px);
		}
		#panel-container{
			margin-top: 55px;
		}

	.grid-button{
		margin-top: 3px;
		font-size: .9rem;
		padding: 6px 13px;
	}

	.screen-container{
		height: 100vh;
		overflow-y: scroll;
		flex: 1;
	}

	.double-grid-container{
		display: flex;
		justify-content: space-around;
		padding-bottom: 5px;

		div.half-grid{
			width: 49%;
			position: relative;
			// height: 430px;

			.grid-overlay{
				position: absolute;
    			top: 0;
				height: 100%;
				width: 100%;
				background: rgba(0,0,0,.3);
				display:flex;
				align-items: center;

				span{
					width:100%;
					text-align:center;
					text-shadow: -1px 1px white;
					font-size: 1.3rem;
					color: rgba(0,0,0,.85);
				}
			}
		}

	}
	.double-grid-btn-container{
		padding-bottom: 3px;
		display: flex;

		span{
			width: calc(50% - 10px);
			margin: 0 5px;
		}

		.button.disabled{
			background-color: gray;
			pointer-events: none;
		}

		.right-grid-button-container {
			display: inline-flex;
			justify-content: space-between;
			align-items: center;

			> .button-div {
				margin-top: 0;
				gap: 1rem;
				align-items: center;
				flex-wrap: wrap;
			}

			.fullscreen-button.button-div {
				margin-top: 0;
				gap: .75rem;
			}
		}
	}

	.gray-button{
		.grid-button;
		box-shadow: none;
		background-color: #dedede;
		color: #383838;
		&:hover{
			background-color: gray;
			color:white;
		}
	}

	.button-container-align-left, .button-container-align-right{
		display: inline-block;
		flex: 1;
	}

	.button-container-align-right{
		text-align: right;
		&.full-width{
			width: 100%;
		}
	}

	.low-height-grid{
		height: 200px;
	}

	.recipe-grid{
		height: 100%;
	}
	
	.button-container{
		display: flex;
    	justify-content: space-between;
	}
}

</style>
